<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Warehouse.NewWarehouseFee')"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content add-warehouse-charge-dialog"
  >
    <div class="section" style="width: 100%">
      <el-form
        label-width="81px"
        style="width: 100%;"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('SeaExport.ChargeItem')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_ChargeItem"
                :default-value="charge.chargeItemId"
                tag-value="itemId"
                tag-name="zhName"
                clearable
                @parentCallBack="changeChargeItem"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('SeaExport.ReceivableType')">
              <el-radio-group v-model="charge.receivable">
                <el-radio :label="1">{{ $t('SeaExport.receivable') }}</el-radio>
                <el-radio :label="0">{{ $t('SeaExport.payable') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('SeaExport.Currency')">
              <cargo-advance-select
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_Currency"
                :default-value="charge.currency"
                @parentCallBack="p=>charge.currency=p.value"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('SeaExport.Unit')">
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_ChargeMeasure"
                filterable
                :clearable="false"
                :tag-name="language"
                :default-value="charge.measure"
                @parentCallBack="p=>charge.measure=p.value"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="jobList"
        :show-side-bar="false"
      />
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Save') }}</el-button>
      <el-button type="default" @click="closeHandler">{{ $t('SeaExport.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import LocalStorageUtils from '@/utils/localStorageUtils'
import StrUtils from '@/utils/StrUtils'
import { Charge } from '@/class/model/act/Charge'
import { batchInsertCharge } from '@/api/clearing/charge'
import { cache, cacheName } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as ChargeUtilsForConstant from '@/class/cargo/model/utils/ChargeUtils'
import { ChargeItem } from '@/class/model/mdm/chargeItem'

export default {
  name: 'AddWarehouseChargeDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    jobList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      charge: {
        receivable: 1,
        currency: 'BRL',
        measure: 'NML'
      },
      office: {},
      department: {},
      user: {},
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', colId: 'jobNo', flex: 1
        },
        {
          headerName: this.$t('SeaExport.Amount'), field: 'wareHouseAmount', colId: 'wareHouseAmount', flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          }
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.inData = {}
        this.outData = {}
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.OFFICE, cacheName.DEPARTMENT, cacheName.USER, cacheName.CONFIG)
      this.office = cache.office
      this.department = cache.department
      this.user = cache.user
      const charge = LocalStorageUtils.getConfiguration('addWarehouseChargeDialog')
      if (!StrUtils.isEmpty(charge)) {
        this.charge = charge
      }
    },
    async saveHandler() {
      if (this.checkWareHouseAmount()) {
        return
      }
      const methods = []
      for (const job of this.jobList) {
        methods.push(await this.getWareHouseCharge(job))
      }
      Promise.all(methods).then(res => {
        const charges = []
        if (res && res.length > 0) {
          for (const item of res) {
            charges.push(item._data)
          }
          batchInsertCharge(charges).then(res => {
            if (res.data > 0) {
              this.$message.success(this.$t('Message.SaveSuccessfully'))
              this.$emit('close')
            }
          })
        }
      })
      LocalStorageUtils.setConfiguration('addWarehouseChargeDialog', this.charge)
    },
    closeHandler() {
      this.$emit('close')
    },
    async getWareHouseCharge(job) {
      const charge = new Charge({})
      charge.inputBy = this.user.userId
      charge.inputDate = new Date()
      charge.inputByDep = this.department.departmentId
      charge.branchId = this.office.officeId
      charge.receivable = this.charge.receivable
      charge.currency = this.charge.currency
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId)
      charge.chargeItemId = this.charge.chargeItemId
      charge.accountId = job.customerId
      ChargeUtils.getChargeisOversea(charge)
      charge.measure = this.charge.measure
      charge.quantity = 1
      charge.unitRate = job.wareHouseAmount
      charge.amount = job.wareHouseAmount
      charge.excludingTaxAmount = job.wareHouseAmount
      charge.taxRate = 0
      charge.taxAmount = 0
      charge.chargeSource = ChargeUtilsForConstant.CHARGE_SOURCE_WAREHOUSE.code
      if (job.jobState === 0 && job.jobState <= 2) {
        charge.chargeState = job.jobState
      }
      charge.jobUuid = job.jobUuid
      return charge
    },
    checkWareHouseAmount() {
      let result = false
      this.gridOptions.api.forEachNode(node => {
        if (!result) {
          const charge = node.data
          const rowIndex = node.rowIndex
          if (charge.wareHouseAmount === 0) {
            this.$message.warning('[' + charge.jobNo + ']' + this.$t('Message.AmountCannotBeZero2'))
            this.gridOptions.api.startEditingCell({ rowIndex, colKey: 'wareHouseAmount' })
            result = true
          }
        }
      })
      return result
    },
    changeChargeItem(p) {
      this.charge['chargeItemId'] = p.value
      const c = ChargeItem.getChargeItemById(p.value)
      if (c != null) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(this.charge.branchId)
        this.charge.currency = !StrUtils.isEmpty(c.defaultArCurrency) ? c.defaultArCurrency : localCurrency
        if (!StrUtils.isEmpty(c.measure)) {
          this.charge.measure = c.measure
        }
      }
    }
  }
}
</script>

<style lang="scss">
.add-warehouse-charge-dialog {
  input.el-input__inner{
    width: 100% !important;
  }
}
</style>
